export default {
  title: '产品列表',
  addProduct: '添加产品',
  editProduct: '编辑产品',
  productName: '产品名称',
  productNo: '产品编号',
  productCategory: '产品分类',
  productLang: '语言版本',
  id: 'ID',
  productInfo: '产品信息',
  retailPrice: '产品零售价',
  spec: '产品规格',
  singleSpec: '单规格',
  multiSpec: '多规格',
  detail: '详情',
  multiSpecModal: '多规格信息',
  specNo: '规格编号',
  specInfo: '规格信息',
  price: '价格',
  select: '选择',
  selected: '已选择',
  selectedProducts: '已选产品',
  unselectedProducts: '未选产品',
};
